<template>
<div class="layout-data-vf-container">
  <div class="search-bar">
    <slot name="search"></slot>
  </div>
  <div class="charts">
    <slot name="charts"></slot>
  </div>
  <div class="table">
    <slot name="table">
    </slot>
  </div>
</div>
</template>

<script>
// import QueryTable from '@/components/QueryTable/'

export default {
  name: 'dataVF',
  components: {
    // QueryTable
  }
}
</script>

<style lang="scss">
.charts,.table {
  margin-top: 20px;
}
.layout-data-vf-container {
  padding: 20px;

  box-sizing: border-box;

  .search-bar {
    width: 100%;
  }
}

.layout-data-vf-container {
  .search-bar-container {
    display: flex;
  }
}
</style>
